import { LitElement, html, PropertyValues } from 'lit';
import { styles } from '../view/styles';
import { WEB_COMPONENT_REMOVE_AD_INTEGRATION } from '../../../../../../webcomponents.constants';
import { translateFn } from '../../../../../../utils/translator.helper';
import { FontSizes, LineHeights } from '../../../../../../types/common/types';
import { GzFormFieldWebComponent } from '../../../../../../ui/gzForm/formField';
import { GzCheckboxWebComponent } from '../../../../../../ui/gzCheckbox';
import { FormGroup } from '../../../../../../ui/gzForm/formGroup/form-group';
import { FormGroupValue } from '../../../../../../ui/gzForm/formGroup/types/form-group-value';
import { customElement, query, state } from 'lit/decorators.js';

/**
 * @summary Content of Isolate Endpoint task pop-up.
 * @tag gz-isolate-endpoint-task
 */
@customElement(WEB_COMPONENT_REMOVE_AD_INTEGRATION)
export class GzRemoveADIntegrationWebComponent extends LitElement {
  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  @query('#remove-unmanaged-machines-checkbox')
  private checkbox: GzFormFieldWebComponent<GzCheckboxWebComponent>;

  @state()
  private formGroup: FormGroup;
  private standardGroupName: string;

  protected firstUpdated(_changedProperties: PropertyValues) {
    super.firstUpdated(_changedProperties);
    this.buildFormGroup();
    this.standardGroupName = Translator.translateProtectedEntityNameByType(
      'Computers and Groups',
      Constants.ProtectedEntities.EPS.CUSTOM_GROUPS,
      Constants.ProductTypes.GRAVITY_ZONE_CLOUD
    );
  }

  public getFormValue(): FormGroupValue {
    return this.formGroup.value;
  }

  private buildFormGroup(): void {
    this.formGroup = FormGroup.build({
      removeUnmanagedMachinesCheckbox: this.checkbox,
    });
  }

  public detachFormEventListeners(): void {
    this.formGroup.unsubscribe();
  }

  render() {
    return html`
      <gz-text lineHeight="${LineHeights.NORMAL}" fontSize="${FontSizes.HEADING_6}"
        >${translateFn('Removing the integration will have the following consequences:')}</gz-text
      >
      <gz-text lineHeight="${LineHeights.NORMAL}" fontSize="${FontSizes.HEADING_6}">
        <span class="has-bullet bullet-neutral">${translateFn('Active Directory Integrators will be removed.')}</gz-text
      >
      <gz-text lineHeight="${LineHeights.NORMAL}" fontSize="${FontSizes.HEADING_6}">
        <span class="has-bullet bullet-neutral">${translateFn(
          'Endpoints joined in Active Directory will be moved directly under {FOLDER_NAME}.',
          {
            FOLDER_NAME: this.standardGroupName,
          }
        )}</gz-text
      >
      <gz-form-field id="remove-unmanaged-machines-checkbox" class="form-field mt-3">
        <gz-checkbox checked gz-form-input label="${translateFn('Remove unmanaged endpoints')}"></gz-checkbox>
      </gz-form-field>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    WEB_COMPONENT_REMOVE_AD_INTEGRATION: GzRemoveADIntegrationWebComponent;
  }
}
